import { render, staticRenderFns } from "./ShiftEditorWork.vue?vue&type=template&id=54f38c5d&scoped=true&lang=pug&"
import script from "./ShiftEditorWork.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorWork.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorWork.vue?vue&type=style&index=0&id=54f38c5d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f38c5d",
  null
  
)

export default component.exports